export enum BaseDefinitionType {
  MeetingMethod, //نحوه آشنایی
  BaseActivity, // زمینه فعالیت
  TaskTitle, // عنوان وظایف
  Tags, // عنوان وظایف
}

export const ListOfBaseDefinitionType = [
  { label: "نحوه آشنایی", value: BaseDefinitionType.MeetingMethod },
  { label: "زمینه فعالیت", value: BaseDefinitionType.BaseActivity },
  { label: "عنوان وظایف", value: BaseDefinitionType.TaskTitle },
  { label: "تگ ها", value: BaseDefinitionType.Tags },
];
